import React, { useContext } from 'react';
import { ProjectContext } from '../../../contexts/ProjectContext';
import { SingleTeamPage } from './SingleTeamPage';

export const TeamPage = ({ isHidden }: { isHidden?: boolean }) => {
    const { selectedTeam } = useContext(ProjectContext);
    return <SingleTeamPage teamId={selectedTeam?.id} isHidden={isHidden} />;
};
